import React from "react";
import { formatMessage } from "lib/globalize-util";
import { FormatMessage } from "react-globalize";
import { ConfirmDialog } from "@nuorder/components";
import { DATA_IDS } from "constants/integration";

interface IOwnProps {
    itemName?: string;
    onConfirm: () => void;
    onClose: () => void;
    isLoading: boolean;
    disableConfirm?: boolean;
}

export const DeleteItemDialog: React.FunctionComponent<IOwnProps> = ({
    onConfirm,
    onClose,
    isLoading,
    disableConfirm,
    itemName,
}) => {
    return (
        <ConfirmDialog
            containerId={DATA_IDS.FOLDERS.DIALOG.DELETE_CONTAINER_ID}
            contentProps={{
                title: formatMessage("Move to Trash?"),
                subText: (
                    <FormatMessage
                        path="Are you sure you want to move [strong]|itemName|[strong] to the Trash?"
                        elements={{ strong: <span style={{ fontWeight: "bold" }} /> }}
                        variables={{
                            itemName,
                        }}
                    />
                ) as any,
            }}
            open={true}
            onConfirm={onConfirm}
            onClose={onClose}
            confirmButtonDisabled={disableConfirm}
            isLoading={isLoading}
            cancelLabel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
            okLabel={formatMessage("Move to Trash")}
        />
    );
};
